function initBuyNowHover(){
  document.querySelectorAll('.product__info .shopify-payment-button__button--unbranded').forEach(button=>{
    if(button.dataset.bogomilHover)return;
    button.dataset.bogomilHover='true';
    button.classList.add('button','bogomil-buy-now');

    const text=document.createElement('span');
    text.className='btn-text';
    while(button.firstChild)text.appendChild(button.firstChild);

    const fill=document.createElement('span');
    fill.className='btn-fill';
    fill.setAttribute('data-fill','');

    button.append(fill,text);
    new theme.HoverButton(button).load();
  });
}

document.addEventListener('page:loaded',initBuyNowHover);
document.addEventListener('variant:change',()=>setTimeout(initBuyNowHover));
if(document.readyState!=='loading')initBuyNowHover();